import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({
  title = "D, Trio Trek — Skardu, Baltistan & Hunza Expeditions",
  description = "Private expeditions through Skardu, Baltistan and Hunza, run by native Gilgit-Baltistan tour professionals.",
  image = "/images/tours/hero-karakoram.jpg",
  url = "https://dtriotrek.com",
}) {
  const fullTitle = title.includes("Trio Trek") ? title : `${title} | D, Trio Trek`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="D, Trio Trek" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}

